import { render, staticRenderFns } from "./CampaignOverview.vue?vue&type=template&id=c0f1c7f6&scoped=true&"
import script from "./CampaignOverview.vue?vue&type=script&lang=js&"
export * from "./CampaignOverview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignOverview.vue?vue&type=style&index=0&id=c0f1c7f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f1c7f6",
  null
  
)

export default component.exports